import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'number_off_site_housing_sites_occupied_workers_managed_2'

export const dataPointDefinition = {
  retracedId: 'number_off_site_housing_sites_occupied_workers_managed_2',
  name: 'Number of off-site housing sites occupied by workers managed and controlled by an entity other than the facility:',
  description:
    'Off-site housing for this question shall mean dormitory-style housing where multiple workers are housed together in a structure that is NOT managed or controlled by the facility but by some other entity.',
  meta: {
    slcpMeta: {
      key: 'fp-bui-5',
      number: 'FP-BUI-7',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {type: 'object', properties: {value: {type: 'string'}}, required: ['value']},
  externalIds: [{id: 'fp-bui-5', version: '1.7.0', provider: 'slcp'}],
  sortingId: 27280,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
